import { render, staticRenderFns } from "./SecurePasswordForm.vue?vue&type=template&id=0f72a766&scoped=true&"
import script from "./SecurePasswordForm.vue?vue&type=script&lang=ts&"
export * from "./SecurePasswordForm.vue?vue&type=script&lang=ts&"
import style0 from "./SecurePasswordForm.vue?vue&type=style&index=0&id=0f72a766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f72a766",
  null
  
)

/* custom blocks */
import block0 from "./SecurePasswordForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports